module.exports = __webpack_public_path__ + "static/media/35-6.1dac75a8.mp3";